import { client } from "api";

export type DeleteChildOrderRequest = { parentOrderId: string; childOrderId: string };
export type DeleteChildOrderResponse = void;

export const deleteChildOrder = ({ parentOrderId, childOrderId }: DeleteChildOrderRequest) =>
  client
    .delete<DeleteChildOrderResponse>(`/order/${parentOrderId}/children/${childOrderId}`)
    .then((res) => res.data);
